import React from "react";
import { useParams } from "react-router";
import STLViewer from "../../containers/patients/STLViewer";
import useApp from "../../store/app/appContext";
import ScansProvider from '../../store/scans/scansProvider';

function STLViwerPage() {
  const { appState: { user }} = useApp();
  if (!user) return '';
  if (!user._id) return '';

  const { scanId, scanName } = useParams(); 

  return (
    <ScansProvider>
      <STLViewer scanId={scanId} scanName={scanName}/>
    </ScansProvider>
  );
}

export default STLViwerPage;
